<span
    *ngIf="!hideCursor && !showInput"
    class="cursor"
    (click)="openDatePicker()">
    <i class="icon-table_filter" [ngClass]="{'highlighted': isFiltered}"></i>
</span>
<div *ngIf="showInput && hideCursor">
    <div class="date-picker-itm" [ngClass]="{'opened': isDateRangePickerVisible}" (click)="openDatePicker()">
        <input type="text"
               placeholder="MM/DD/YYYY - MM/DD/YYYY"
               [value]="!!start && !!end ? (start | date: bsConfig.rangeInputFormat) +' - '+ (end | date: bsConfig.rangeInputFormat) : null"
               class="form-control date-picker-input">
    </div>
</div>
<div
    *ngIf="isDateRangePickerVisible"
    class="date-range-picker-container"
    [ngClass]="{
        'position-left': positionDateRange === 'left',
        'position-left-center': positionDateRange === 'left-center',
        'position-bottom-center': positionDateRange === 'bottom-center',
        'position-left-top': positionDateRange === 'left-top',
        'position-right': positionDateRange === 'right',
        'position-mobile-bottom-center': positionDateRange === 'mobile-bottom-center'
        }">
    <div class="sort-wrapper" *ngIf="hasSort">
        <strong class="title">Sort:</strong>
        <span (click)="sort(' ' + sortOrders.ASC)"
              class="sort"
              [ngClass]="{ 'active-sort': isAsc() }">
              <span class="sort-icon icon-arrow-down-special"></span>
                  A–Z
        </span>

        <span (click)="sort(' ' + sortOrders.DESC)"
              class="sort"
              [ngClass]="{ 'active-sort': isDesc() }">
              <span class="sort-icon icon-arrow-up-special"></span>
                  Z-A
        </span>
    </div>

    <div class="date-pickers-wrapper">
        <div class="d-flex">
            <bs-datepicker-inline
                class="min-date-datepicker"
                [bsConfig]="bsConfig"
                [(bsValue)]="start"
                (bsValueChange)="updateError()">
            </bs-datepicker-inline>
            <bs-datepicker-inline
                class="max-date-datepicker"
                [bsConfig]="bsConfig"
                [(bsValue)]="end"
                (bsValueChange)="updateError()">
            </bs-datepicker-inline>
        </div>

        <div class="error-text" *ngIf="error">{{error}}</div>
    </div>

    <div class="button-wrapper">
        <button id="clear-dpicker"
            appTrackClickButton
            class="button secondary" (click)="clear($event)">{{ 'Clear' }}</button>
        <button id="cancel-dpicker"
             appTrackClickButton
            class="button secondary" (click)="cancel($event)">{{ 'Cancel' }}</button>
        <button id="apply-dpicker"
            appTrackClickButton
            class="button primary" (click)="apply($event)" [disabled]="isApplyDisabled()">{{ 'Apply' }}</button>
    </div>

</div>


